export default "__VITE_ASSET__a6d6f8b0__"